<template>
  <div>
    <b-row class="match-height mb-5">
      <b-col>
        <b-row class="border-bottom mb-2">
          <b-col>
            <h4>Site Summary</h4>
          </b-col>
        </b-row>

        <b-row class="mb-2">

          <b-col>
            <p><b>Name:</b></p>
            <kbd>{{ newSite.details.name }}</kbd>
          </b-col>

        </b-row>

        <b-row class="border-bottom mb-2">
          <b-col>
            <h4>Site Location</h4>
          </b-col>
        </b-row>

        <b-row class="mb-2">
          <b-col>
            <p>
              <b>Address</b>
            </p>
            <kbd> {{ newSite.details.address }}</kbd>
          </b-col>

          <b-col>
            <p>
              <b>Zip Code</b>
            </p>
            <kbd>
              {{ newSite.details.zip_code }}
            </kbd>
          </b-col>

          <b-col>
            <p>
              <b>City</b>
            </p>
            <kbd>
              {{ newSite.details.city }}
            </kbd>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <p>
              <b>Sub Region</b>
            </p>
            <kbd> {{ newSite.details.subRegion }}</kbd>
          </b-col>

          <b-col>
            <p>
              <b>Region</b>
            </p>
            <kbd>
              {{ newSite.details.region }}
            </kbd>
          </b-col>

          <b-col>
            <p>
              <b>Country</b>
            </p>
            <kbd>
              {{ newSite.details.country }}
            </kbd>
          </b-col>
        </b-row>

        <div
          v-if="newSite.objects.length > 0"
        >
          <b-row class="border-bottom mb-2 mt-2">
            <b-col>
              <h4>Objects</h4>
            </b-col>
          </b-row>

          <b-row class="border-bottom mb-2">

            <b-table
              :items="newSite.objects"
              small
              :fields="objectFields"
            />

          </b-row>
        </div>

      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BTable,
} from 'bootstrap-vue'

export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    BRow,
    BCol,
    BTable,
  },
  props: {
    newSite: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      summary: [],
      objectFields: [
        { key: 'name', label: ' Name', sortable: true },
        { key: 'manufacturerSerialNumber', label: 'Serial Number', sortable: true },
        { key: 'manufacturer', label: 'Manufacturer', sortable: true },
        { key: 'model', label: 'Model', sortable: true },
        { key: 'modelNumber', label: 'Model Number', sortable: true },
      ],
    }
  },
  watch: {
    newSite: {
      deep: true,
      handler(newVal) {
        this.newSite = newVal
      },
    },
  },
}
</script>

<style>

</style>
